import { Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { OffboardingWizardValues } from '../../../../types/offboardings';
import { staggerSx } from '../../../../helpers/styles/offboardings';
import OptionItem from '../OptionItem';

function AccessStep({ employeeName }: { employeeName: string }) {
  const { values, setFieldValue } = useFormikContext<OffboardingWizardValues>();
  return (
    <Stack
      gap={1.5}
      sx={staggerSx}
      role="radiogroup"
      aria-label="Should they keep customer access?">
      <OptionItem
        selected={values.retainCustomerAccess === 'true'}
        onClick={() => setFieldValue('retainCustomerAccess', 'true')}
        title="Retain access"
        description={`${employeeName} keeps visibility into customers they served while here.`}
        aside="Default"
      />
      <OptionItem
        selected={values.retainCustomerAccess === 'false'}
        onClick={() => setFieldValue('retainCustomerAccess', 'false')}
        title="Restrict access"
        description={`${employeeName} can no longer view customers from this shop after they leave.`}
      />
    </Stack>
  );
}

export default AccessStep;
